;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { PricingTier } from "@/prisma/generated/enums";
import type { PermissionItem } from "./permissions";
import type { UserRole } from "./user";
export enum OrganizationStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export interface Organization {
	id: string;
	name: string;
	address: string;
	isOnboarded: boolean;
	status: OrganizationStatus;
	logo?: string | null;
	createdAt: string;
	users: OrganizationMember[];
	dataProviders: DataProvider[];
	pricingTier?: PricingTier;
	expiresAt?: string | null;
	tierAllowedSystemViewNames?: string[];
}

export interface DataProvider {
	id: string;
	type: string;
	name: string;
	logo?: string;
	createdAt: string;
}

export interface OrganizationMember {
	id: string;
	isSupportUser?: boolean;
	firstName: string;
	lastName: string;
	email: string;
	role: UserRole;
	orgPermissions: PermissionItem[];
	createdAt: string;
	profilePicture?: string | null;
}
